import {
    ADD_PROFILEPHOTO_START,
    ADD_PROFILEPHOTO_SUCCESS,
    ADD_PROFILEPHOTO_FAILURE,
    ADD_PROFILEPHOTO_RESET,
} from "./actionTypes";

const initialState = {
    
    imagedata: null,
    error: null,
    imgAddMsg: "",
    uploading: false,
    uploaded: false,
};

const profilePhotoReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_PROFILEPHOTO_START:

            return {
                ...state,
                error: null,
                imgAddMsg: "",
                uploaded: false,
                uploading: true,
            };

        case ADD_PROFILEPHOTO_SUCCESS:
           
            return {
                ...state,
                imagedata: action.payload,
                error: null,
                uploaded: true,
                uploading: false,
            };

        case ADD_PROFILEPHOTO_FAILURE:
            return {
                ...state,
                uploading: false,
                imagedata: null,
                error: action.payload,
                uploaded: false,
            };

        case ADD_PROFILEPHOTO_RESET:
            return {
                initialState,
                imgAddMsg: "",
                
            };
        default:
            return state;
    }
};

export default profilePhotoReducer;
